import FJGenerateButton from '../../../../../common/components/FJGenerateButton/FJGenerateButton.jsx';
import { useDispatch, useSelector } from 'react-redux';
import FJTextBasedEditingConfig from '../../../../../config/appConfig/FJTextBasedEditingConfig.js';
import styles from './FJGenerateButtonContainer.module.less';
import FJActionTextBasedEditing from '../../../../../redux/action/textBasedEditing/FJActionTextBasedEditing.js';
import FJHistoryVideoEditIcon from '../../../../../assets/svg/history.svg?react';
import FJIconButton from '../../../../../common/components/FJIconButton/FJIconButton.jsx';
import FJToolTip from '../../../../../common/components/FJToolTip/FJToolTip.jsx';
import FJLocalStore from '../../../../../store/FJLocalStore.js';

const FJGenerateButtonContainer = () => {
    const dispatch = useDispatch();
    const taskStatus = useSelector(state => state.common.taskStatus);
    const freeNumCreation = useSelector(state => state.common.freeNumCreation);
    const creditNumber = useSelector(state => state.common.creditNumber);
    const isProjectLoading = useSelector(state => state.common.isProjectLoading);
    const duration = useSelector(state => state.textBasedEditing.originalResourceData.duration);
    const historyData = useSelector(state => state.textBasedEditing.historyData);
    const hasResource = useSelector(state => {
        return state.textBasedEditing.originalResourceData.url !== '';
    });

    const _onGenerate = () => {
        dispatch(FJActionTextBasedEditing.onGenerateAction());
    };

    const useCredit = hasResource
        ? Number((Math.ceil(duration / 60) * FJTextBasedEditingConfig.unitPrice).toFixed(2))
        : 0;
    const isFree = freeNumCreation > 0 && creditNumber < useCredit;

    const _openHistory = () => {
        dispatch(FJActionTextBasedEditing.restoreHistoryAction());
    };

    return (
        <div className={styles.button_box}>
            {historyData && (
                <FJToolTip title={FJLocalStore._('previous-transcript')}>
                    <div className={styles.history_box}>
                        <FJIconButton
                            className={styles.history_btn}
                            icon={<FJHistoryVideoEditIcon />}
                            onClick={_openHistory}
                        />
                    </div>
                </FJToolTip>
            )}
            <FJGenerateButton
                text={'transcribe'}
                className={styles.generate_btn}
                onClick={_onGenerate}
                taskStatus={taskStatus}
                freeNumCreation={freeNumCreation}
                isFree={isFree}
                useCredit={useCredit}
                isProjectLoading={isProjectLoading}
                isShowUsageDetail={hasResource}
            />
        </div>
    );
};

export default FJGenerateButtonContainer;
